var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OzContainedButton',{attrs:{"color-scheme":_vm.buttonColorScheme,"data-status":_vm.currentStatus,"text":_vm.buttonText,"title":_vm.buttonLabel,"aria-label":_vm.buttonLabel,"aria-live":"polite"},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }